export default "__VITE_ASSET__476a3dc7__"